import { isObject, Timestamp, TypeGuard } from '@principle-theorem/shared';

export enum ManagementApiAction {
  GetAuthUserStatus = 'getAuthUserStatus',
  SetEmailVerified = 'setEmailVerified',
  GeneratePasswordResetLink = 'generatePasswordResetLink',
}

export interface IProviderInfo {
  providerId: string;
  uid: string;
  displayName?: string;
  email?: string;
  photoURL?: string;
}

export interface IAuthUserStatus {
  exists: boolean;
  uid?: string;
  email?: string;
  emailVerified?: boolean;
  disabled?: boolean;
  creationTime?: string;
  lastSignInTime?: string;
  providerData?: IProviderInfo[];
}

export interface IPasswordResetLinkResponse {
  link: string;
  email: string;
  expiresIn: string;
  expiresAt: Timestamp;
}

export interface IManagementApiEmailData {
  email: string;
}

export interface IGetAuthUserStatusRequest {
  action: ManagementApiAction.GetAuthUserStatus;
  data: IManagementApiEmailData;
}

export interface ISetEmailVerifiedRequest {
  action: ManagementApiAction.SetEmailVerified;
  data: IManagementApiEmailData;
}

export interface IGeneratePasswordResetLinkRequest {
  action: ManagementApiAction.GeneratePasswordResetLink;
  data: IManagementApiEmailData;
}

export type ManagementApiRequest =
  | IGetAuthUserStatusRequest
  | ISetEmailVerifiedRequest
  | IGeneratePasswordResetLinkRequest;

export type ManagementApiResponse =
  | IAuthUserStatus
  | IPasswordResetLinkResponse;

export interface IManagementAuditLog {
  action: ManagementApiAction;
  callerUid: string;
  callerName: string;
  callerEmail: string;
  targetEmail: string;
  success: boolean;
  error?: string;
  timestamp: Timestamp;
  expiresAt: Timestamp;
}

export const isManagementApiRequest = TypeGuard.interface<ManagementApiRequest>(
  {
    action: TypeGuard.enumValue(ManagementApiAction),
    data: isObject,
  }
);
